<template>
  <div class="con">
    <div class="con-flex">
      <!-- 加载状态 -->
      <div class="loading-overlay" v-if="loading">
        <van-loading type="spinner" color="#27BEC4" />
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 错误状态 -->
      <div class="error-overlay" v-if="error && !loading">
        <van-icon name="failure" color="#FF6B6B" size="40px" />
        <div class="error-text">加载失败，请刷新重试</div>
        <button class="retry-btn" @click="GetSysPerson">重新加载</button>
      </div>

      <!-- 顶部导航栏 -->
      <div class="top-nav">
        <div class="hospital-name">天峨县妇幼保健院</div>
        <div class="user-info" @click="toPatientList">
          <div class="user-avatar" v-if="cardId.name && cardId.name != ''">
            <span class="avatar-text">{{ getFirstChar(cardId.name) }}</span>
          </div>
          <div class="user-avatar default" v-else>
            <van-icon name="user" color="#fff" size="24px" />
          </div>
          <div class="user-details">
            <div class="user-name">{{ cardId.name || "未登录" }}</div>
            <div class="user-id" v-if="cardId.sfzh && cardId.sfzh != ''">
              {{ cardId.sfzh }}
            </div>
            <div class="user-id" v-else>请添加就诊卡</div>
          </div>
          <van-icon name="arrow" color="#fff" size="16px" />
        </div>
      </div>

      <!-- Banner模块 -->
      <div class="banner-section">
        <img
          src="../assets/homebanner.png"
          alt="医疗服务"
          class="banner-image"
        />
      </div>

      <!-- 患者信息模块 -->
      <!-- <div class="patient-section" @click="toPatientList">
				<div class="patient-header">
					<div class="ph-title">患者信息</div>
					<div class="ph-tag">点击管理</div>
				</div>
				<div v-if="cardId.name && cardId.name != ''" class="patient-card">
					<div class="patient-avatar">
						<span class="avatar-text">{{getFirstChar(cardId.name)}}</span>
					</div>
					<div class="patient-info">
						<div class="pi-name">{{cardId.name}}</div>
						<div class="pi-detail">
							<span class="pi-label">门诊ID:</span>
							<span class="pi-value">{{cardId.mzh || '无'}}</span>
						</div>
						<div class="pi-detail">
							<span class="pi-label">住院ID:</span>
							<span class="pi-value">{{cardId.zyh || '无'}}</span>
						</div>
						<div class="pi-detail">
							<span class="pi-label">身份证:</span>
							<span class="pi-value">{{maskId(cardId.sfzh)}}</span>
						</div>
					</div>
					<div class="patient-arrow">
						<van-icon name="arrow" color="#999" size="16px" />
					</div>
				</div>
				<div v-else class="add-card">
					<div class="add-content">
						<div class="add-icon">
							<van-icon name="plus" color="#27BEC4" size="32px" />
						</div>
						<div class="add-text">
							<div class="add-main-text">添加就诊卡</div>
							<div class="add-sub-text">点击添加患者信息</div>
						</div>
					</div>
				</div>
			</div> -->

      <!-- 主要功能卡片 -->
      <!-- <div class="main-functions">
				<div class="function-card" @click="navBtn(0)">
					<div class="card-content">
						<div class="card-title">预约挂号</div>
						<div class="card-desc">轻松看专家</div>
					</div>
				</div>
				<div class="function-card payment" @click="navBtn(1)">
					<div class="card-content">
						<div class="card-title">充值缴费</div>
						<div class="card-desc">随时随地缴费</div>
					</div>
				</div>
			</div> -->

      <!-- 服务分类 -->
      <div class="service-section">
        <div class="service-header">
          <div class="service-title">医疗服务</div>
        </div>

        <!-- 服务内容 -->
        <div class="service-content">
          <div
            class="service-item"
            v-for="(item, index) in navList"
            :key="index"
            @click="navBtn(item.id)"
          >
            <div class="service-icon">
              <img :src="item.img" />
            </div>
            <div class="service-text">{{ item.text }}</div>
          </div>
        </div>
      </div>

      <!-- 医院公告列表 -->
      <!-- <div class="notice-section">
				<div class="notice-section-header">
					<span class="notice-section-title">最新公告</span>
					<span class="notice-section-more" @click="toNotice">更多</span>
				</div>
				<div class="notice-list">
					<div class="notice-item" v-for="(item, index) in noticeList" :key="index" @click="toNoticeDetail(item.id)">
						<van-icon name="info-o" color="#27BEC4" size="16px" />
						<div class="notice-item-content">
							<div class="notice-item-title">{{item.title}}</div>
							<div class="notice-item-time">{{item.time}}</div>
						</div>
					</div>
				</div>
			</div> -->
    </div>

    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div class="nav-item active">
        <van-icon name="home-o" color="#27BEC4" size="24px" />
        <div class="nav-text">首页</div>
      </div>
      <div class="nav-item" @click="toUser">
        <van-icon name="user-o" color="#999" size="24px" />
        <div class="nav-text">个人中心</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      navList: [
        {
          id: 0,
          text: "预约挂号",
          img: require("../assets/bereg.png"),
          to: "/registered",
        },
        {
          id: 1,
          text: "结算缴费",
          img: require("../assets/payCost.png"),
          to: "/payCost",
        },
        {
          id: 2,
          text: "费用清单",
          img: require("../assets/auscultation.png"),
          to: "/paymentRecordsList",
        },
        {
          id: 3,
          text: "门诊报告",
          img: require("../assets/inHospital.png"),
          to: "/report",
        },
        {
          id: 4,
          text: "住院服务",
          img: require("../assets/inHospital.png"),
          to: "/inpatient",
        },
        {
          id: 5,
          text: "咨询医生",
          img: require("../assets/Customer.png"),
          to: "/communicationList",
        },
      ],
      // 医院公告列表
      noticeList: [
        {
          id: 1,
          title: "关于2024年春节期间门诊安排的通知",
          time: "2024-02-01",
        },
        {
          id: 2,
          title: "医院新引进高端医疗设备投入使用",
          time: "2024-01-20",
        },
        {
          id: 3,
          title: "专家门诊时间调整通知",
          time: "2024-01-15",
        },
      ],
      cardId: {}, //卡号
      userInfo: null,
      getuserTime: null,
      getuserNum: 0,
      loading: false, // 加载状态
      error: false, // 错误状态
      patientList: [], // 所有患者信息列表
      activePatientIndex: 0, // 当前选中的患者索引
    };
  },
  //动态监听this.$store.state.token 是否有值
  watch: {
    "$store.state.token": {
      handler(newVal, oldVal) {
        console.log("token变化监听触发:", newVal, oldVal);
        if (newVal && newVal !== oldVal) {
          console.log("token更新，重新获取用户信息");
          this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.GetSysPerson();
        }
      },
      immediate: true, // 立即执行一次
      deep: true,
    },
  },
  methods: {
    //获取微信挂号人员信息
    GetSysPerson() {
      let that = this;
      that.loading = true;
      that.error = false;
      if (this.userInfo != null) {
        clearTimeout(that.getuserTime);
        that.$Axios
          .Get("/person/sysPerson?wechatId=" + this.userInfo.openid, null)
          .then((data) => {
            that.loading = false;
            console.log(data);
            if (data.code == 0) {
              let dataList = data.msg;
              // 存储所有患者信息
              that.patientList = [];
              for (let i = 0; i < dataList.length; i++) {
                dataList[i].relation =
                  dataList[i].relation == "01" ? "本人" : "他人";
                dataList[i].status =
                  dataList[i].status == "1" ? "正常" : "已注销";
                that.patientList.push(dataList[i]);
                // 设置默认选中的患者
                if (dataList[i].choice == 0 || that.patientList.length === 1) {
                  that.cardId = dataList[i];
                  that.activePatientIndex = i;
                  localStorage.setItem(
                    "cardUserInfo",
                    JSON.stringify(dataList[i]),
                  );
                }
              }
            }
          })
          .catch((err) => {
            that.loading = false;
            that.error = true;
            localStorage.setItem("cardUserInfo", "");
            that.$toast("网络未连接");
            console.log(err);
            if (that.getuserNum < 5) {
              that.getuserNum++;
              that.getuserTime = setTimeout(() => {
                that.GetSysPerson();
              }, 3000);
            } else {
              clearTimeout(that.getuserTime);
            }
          });
      } else {
        that.loading = false;

        console.log("用户信息为空后", this.userInfo);
        if (that.getuserNum < 5) {
          that.getuserNum++;
          that.getuserTime = setTimeout(() => {
            that.GetSysPerson();
          }, 1000);
        } else {
          that.error = true;
          clearTimeout(that.getuserTime);
        }
      }
    },

    // 切换患者
    switchPatient(index) {
      this.activePatientIndex = index;
      this.cardId = this.patientList[index];
      localStorage.setItem("cardUserInfo", JSON.stringify(this.cardId));
    },

    // 获取姓名首字
    getFirstChar(name) {
      if (!name) return "?";
      return name.charAt(0);
    },

    // 进入患者列表页面
    toPatientList() {
      this.$router.push("/patient");
    },

    navBtn(e) {
      let toUrl = this.navList[e].to;
      if (this.cardId.name && this.cardId.name != "") {
        if (toUrl === "/report") {
          this.toOutReport(this.cardId.brkh);
          return;
        }
        this.$router.push(toUrl);
      } else {
        this.$toast("请添加就诊卡");
      }
    },
    //个人中心
    toUser() {
      this.$router.replace({
        path: "/user",
      });
    },
    //客服
    customer() {
      this.$router.push({
        path: "/communicationList",
      });
    },
    //医院介绍
    introduce() {
      this.$router.push({
        path: "/Inintroduce",
      });
    },
    //添加就诊卡
    addCard() {
      this.$router.push("/patient");
    },
    //门店报告
    toOutReport(brid) {
      this.$router.push({
        path: "/report",
        query: {
          brid: brid,
          type: 1, //2、住院 1、门诊
        },
      });
    },
    // 跳转到公告列表
    toNotice() {
      this.$router.push({
        path: "/noticeList",
      });
    },
    // 跳转到公告详情
    toNoticeDetail(id) {
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: id,
        },
      });
    },
  },

  mounted() {
    this.$store.commit("Load", false);
    this.getuserNum = 0;

    if (this.$store.state.token) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.GetSysPerson();
    }
  },
};
</script>

<style scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.con {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
}

.con-flex {
  flex: 1;
  overflow-y: auto;
  position: relative;
}

/* 顶部导航栏样式 */
.top-nav {
  background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.hospital-name {
  font-size: 18px;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.user-info:hover {
  transform: translateY(-2px);
}

.user-avatar {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.user-avatar.default {
  background-color: rgba(255, 255, 255, 0.3);
}

.avatar-text {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-id {
  font-size: 12px;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Banner模块样式 */
.banner-section {
  margin: 0 0 15px 0;
  box-shadow: 0 4px 16px rgba(39, 190, 196, 0.3);
  overflow: hidden;
  border-radius: 8px;
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 患者信息模块样式 */
.patient-section {
  margin: 0 15px 20px 15px;
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  color: #333;
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.patient-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(39, 190, 196, 0.15);
}

/* 患者信息头部 */
.patient-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.ph-title {
  font-size: 16px;
  font-weight: 600;
  color: #27bec4;
}

.ph-tag {
  font-size: 12px;
  background-color: rgba(39, 190, 196, 0.1);
  color: #27bec4;
  padding: 3px 10px;
  border-radius: 15px;
}

/* 添加就诊卡样式 */
.add-card {
  background-color: #f0f8f0;
  padding: 30px;
  border-radius: 8px;
  border: 2px dashed #27bec4;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.add-card:hover {
  background-color: #e8f5e8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(39, 190, 196, 0.2);
}

.add-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.add-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-text {
  text-align: center;
}

.add-main-text {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #27bec4;
}

.add-sub-text {
  font-size: 14px;
  color: #666;
}

/* 患者卡片样式 */
.patient-card {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.patient-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(39, 190, 196, 0.15);
  border-color: #27bec4;
}

/* 左侧首字图标 */
.patient-avatar {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(39, 190, 196, 0.3);
  color: #fff;
}

/* 右侧信息区域 */
.patient-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pi-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.pi-detail {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.pi-label {
  font-size: 11px;
  color: #666;
  font-weight: 500;
  min-width: 70px;
}

.pi-value {
  font-size: 12px;
  font-weight: 500;
  color: #333;
  flex: 1;
}

/* 右侧箭头 */
.patient-arrow {
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

/* 主要功能卡片 */
.main-functions {
  margin: 0 15px 20px 15px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.function-card {
  background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
  padding: 20px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(39, 190, 196, 0.3);
  text-align: center;
}

.function-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(39, 190, 196, 0.4);
}

.function-card.payment {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

.function-card.payment:hover {
  box-shadow: 0 6px 16px rgba(33, 150, 243, 0.4);
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.card-desc {
  font-size: 14px;
  opacity: 0.9;
}

/* 服务分类 */
.service-section {
  margin: 0 15px 20px 15px;
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.service-header {
  margin-bottom: 15px;
}

.service-title {
  font-size: 16px;
  font-weight: 600;
  color: #27bec4;
  padding-left: 12px;
  border-left: 3px solid #27bec4;
}

.service-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}

.service-tab {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f5f5f5;
}

.service-tab:hover {
  background-color: rgba(39, 190, 196, 0.1);
  color: #27bec4;
}

.service-tab.active {
  background-color: #27bec4;
  color: #fff;
  box-shadow: 0 2px 6px rgba(39, 190, 196, 0.3);
}

/* 服务内容 */
.service-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f9f9f9;
  border: 1px solid #e9ecef;
}

.service-item:hover {
  transform: translateY(-2px);
  background-color: #f0f8f0;
  border-color: #27bec4;
  box-shadow: 0 3px 8px rgba(39, 190, 196, 0.15);
}

.service-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.service-icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.service-text {
  font-size: 14px;
  color: #333;
  text-align: center;
  font-weight: 500;
}

/* 医院公告列表 */
.notice-section {
  margin: 0 15px 20px 15px;
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.notice-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.notice-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #27bec4;
  padding-left: 12px;
  border-left: 3px solid #27bec4;
}

.notice-section-more {
  font-size: 14px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s ease;
}

.notice-section-more:hover {
  color: #27bec4;
}

.notice-list {
  margin-top: 10px;
}

.notice-item {
  display: flex;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.notice-item:last-child {
  border-bottom: none;
}

.notice-item:hover {
  background-color: rgba(39, 190, 196, 0.05);
  padding-left: 10px;
  border-radius: 8px;
}

.notice-item-content {
  flex: 1;
  overflow: hidden;
}

.notice-item-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.notice-item-time {
  font-size: 12px;
  color: #999;
}

/* 底部导航 */
.bottom-nav {
  background: #fff;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  bottom: 0;
  z-index: 100;
}

.bottom-nav .nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 5px 20px;
  border-radius: 8px;
}

.bottom-nav .nav-item:hover {
  background-color: rgba(39, 190, 196, 0.1);
}

.bottom-nav .nav-item.active {
  color: #27bec4;
}

.bottom-nav .nav-text {
  font-size: 12px;
  margin-top: 2px;
}

/* 加载状态样式 */
.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  color: #27bec4;
}

/* 错误状态样式 */
.error-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.error-text {
  margin: 15px 0;
  font-size: 16px;
  color: #666;
}

.retry-btn {
  margin-top: 10px;
  padding: 10px 24px;
  background-color: #27bec4;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-btn:hover {
  background-color: #1a9ea4;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(39, 190, 196, 0.3);
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-section {
  animation: fadeInUp 0.5s ease-out;
}

.patient-section {
  animation: fadeInUp 0.6s ease-out;
}

.main-functions {
  animation: fadeInUp 0.7s ease-out;
}

.service-section {
  animation: fadeInUp 0.8s ease-out;
}

.notice-section {
  animation: fadeInUp 0.9s ease-out;
}

/* 响应式设计 */
@media (max-width: 768px) {
  /* 顶部导航栏 */
  .top-nav {
    padding: 12px;
  }

  .hospital-name {
    font-size: 16px;
  }

  .user-avatar {
    width: 36px;
    height: 36px;
  }

  .avatar-text {
    font-size: 14px;
  }

  .user-name {
    font-size: 13px;
  }

  .user-id {
    font-size: 11px;
  }

  /* Banner模块 */
  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .banner-icon {
    order: -1;
    width: 50px;
    height: 50px;
  }

  .banner-text h2 {
    font-size: 16px;
  }

  /* 患者信息模块 */
  .patient-section {
    margin: 0 12px 15px 12px;
    padding: 12px;
  }

  .ph-title {
    font-size: 15px;
  }

  .patient-card {
    padding: 10px;
  }

  .patient-avatar {
    width: 38px;
    height: 38px;
    margin-right: 10px;
  }

  .avatar-text {
    font-size: 16px;
  }

  .pi-name {
    font-size: 14px;
  }

  .pi-detail {
    font-size: 11px;
  }

  .pi-label {
    min-width: 60px;
    font-size: 10px;
  }

  .pi-value {
    font-size: 11px;
  }

  /* 主要功能卡片 */
  .main-functions {
    margin: 0 12px 15px 12px;
    gap: 12px;
  }

  .function-card {
    padding: 15px;
  }

  .card-title {
    font-size: 15px;
  }

  .card-desc {
    font-size: 13px;
  }

  /* 服务分类 */
  .service-section {
    margin: 0 12px 15px 12px;
    padding: 12px;
  }

  .service-title {
    font-size: 15px;
  }

  .service-tabs {
    gap: 8px;
  }

  .service-tab {
    padding: 6px 12px;
    font-size: 13px;
  }

  /* 服务内容 */
  .service-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .service-item {
    padding: 12px;
  }

  .service-icon {
    width: 40px;
    height: 40px;
  }

  .service-icon img {
    width: 24px;
    height: 24px;
  }

  .service-text {
    font-size: 13px;
  }

  /* 医院公告 */
  .notice-section {
    margin: 0 12px 80px 12px;
    padding: 12px;
  }

  .notice-section-title {
    font-size: 15px;
  }

  .notice-item {
    padding: 10px 0;
  }

  .notice-item-title {
    font-size: 13px;
  }

  /* 底部导航 */
  .bottom-nav {
    padding: 8px 0;
  }

  .bottom-nav .nav-item {
    padding: 5px 15px;
  }

  .bottom-nav .nav-text {
    font-size: 11px;
  }
}
</style>
